import React from "react";
import { Helmet } from "react-helmet";
import style from "./Games.module.scss";
import { GameCard } from "./components/GameCard/GameCard";
import { gameList } from "./helpers";
import type { Game } from "./types";

export const Games = () => {
	const gamesNames = gameList.map((game: Game) => game.name);
	const pageTitle = "Games - SkillerDome";
	const pageDescription = `Discover our collection of games: ${gamesNames.join(", ")}. Play and have fun!`;
	const courseSchema = {
		"@context": "https://schema.org",
		"@type": "ItemList",
		itemListElement: gameList.map((game, index) => ({
			"@type": "ListItem",
			position: index + 1,
			item: {
				"@type": "Game",
				name: game.name,
				description: game.description,
				image: game.image,
				provider: {
					"@type": "Organization",
					name: "SkillerDome",
					url: "https://skillerdome.com",
				},
				offers: {
					"@type": "Offer",
					url: `https://skillerdome.com/courses/${game.name}`,
					price: "0", // Indicate the course is free
					priceCurrency: "USD",
					availability: "https://schema.org/InStock",
				},
				hasCourseInstance: {
					"@type": "GameInstance",
					courseMode: game.type || "General",
					availabilityStarts: "2024-01-01T00:00:00Z",
					location: {
						"@type": "Place",
						name: "SkillerDome Headquarters",
						address: {
							"@type": "PostalAddress",
							streetAddress: "123 Learning Ave",
							addressLocality: "Education City",
							postalCode: "12345",
							addressCountry: "US",
						},
					},
				},
			},
		})),
	};
	return (
		<div className={style.gamesPage}>
			<Helmet>
				<title>{pageTitle}</title>
				<meta name="description" content={pageDescription} />
				<meta
					name="keywords"
					content="games, learning, education, snake game, blurred image game, memory card game"
				/>
				<meta name="robots" content="index, follow" />

				{/* JSON-LD structured data */}
				<script type="application/ld+json">
					{JSON.stringify(courseSchema)}
				</script>
			</Helmet>
			<div className={style.gamesPage__container}>
				{gameList.map((game: Game) => (
					<GameCard key={game.name} game={game} />
				))}
			</div>
		</div>
	);
};
